import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import './styles.scss'
import { apiInchat } from 'api'
import inchatActions from 'redux/inchat/actions'
import ScheduleMsgModal from 'components/Chat/ScheduleMsgModal'
import ModalDelete from 'components/ModalDelete'
import BarSelector from './BarSelector'
import ScheduledContent from './ScheduledContent'
import DraftsContent from './DraftsContent'
import { lang } from 'utils/helpers'
import { toastMessage } from 'utils/messages'

const Drafts = ({ page }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const [drafts, setDrafts] = useState([])
  const [isOpenScheduleMsgModal, setIsOpenScheduleMsgModal] = useState(false)
  const [isSchedulingMessage, setIsSchedulingMessage] = useState(false)
  const [schedulingMessageError, setSchedulingMessageError] = useState('')
  const [messageTemp, setMessageTemp] = useState(null)
  const [openModalDelete, setOpenModalDelete] = React.useState(false)
  const [isSubmitDelete, setIsSubmitDelete] = React.useState(false)
  const inchat = useSelector((state) => state.inchat)

  useEffect(() => {
    getDrafts()
  }, [])

  const getDrafts = async () => {
    dispatch(inchatActions.getDrafts())
      .then((data) => {
        setDrafts(data)
      })
      .catch(() => {
        toastMessage(lang('inchat_error_get_drafts'), 'error')
      })
  }

  const scheduleMessage = scheduledAt => {
    if (schedulingMessageError) setSchedulingMessageError('')
    const message = messageTemp || ''
    if (!message) {
      setSchedulingMessageError(lang('dashboard_message-text-empty'))
      return
    }

    const data = {
      conversationId: message.conversationInfo._id,
      message: message.content.replace( /(<([^>]+)>)/ig, ''),
      scheduledAt,
      attachments: message.attachments?.length > 0 ? message.attachments : undefined,
    }

    setIsSchedulingMessage(true)
    apiInchat.scheduleMessage(data)
      .then(async () => {
        toastMessage(lang('dashboard_message-scheduled-successfully'))
        toggleScheduleMsgModal()
        dispatch(inchatActions.cleanComposer(message.conversationInfo._id, message.isThread))

        //Eliminar el draft
        try {
          await apiInchat.draftRemove({ conversationId: message.conversationInfo._id, draftId: message._id })
          dispatch(inchatActions.cleanComposer(message.conversationInfo._id, message.isThread))
          getDrafts()
        } catch (error) {
          console.log(error)
        }
      })
      .catch(() => toastMessage(lang('dashboard_message-scheduled-error'), 'error'))
      .finally(() => {
        setMessageTemp(null)
        setIsSchedulingMessage(false)
      })
  }

  const toggleScheduleMsgModal = () => {
    if (schedulingMessageError) setSchedulingMessageError('')
    isOpenScheduleMsgModal && setMessageTemp(null)
    setIsOpenScheduleMsgModal(prevState => !prevState)
  }

  const deleteMessage = async () => {
    //Eliminar el draft
    try {
      setIsSubmitDelete(true)
      await apiInchat.draftRemove({ conversationId: messageTemp.conversationInfo._id, draftId: messageTemp._id })
      dispatch(inchatActions.cleanComposer(messageTemp.conversationInfo._id, messageTemp.isThread))
      toggleDelete()
      getDrafts()
    } catch (error) {
      console.log(error)
    } finally {
      setMessageTemp(null)
      setIsSubmitDelete(false)
    }
  }

  const toggleDelete = () => {
    openModalDelete && setMessageTemp(null)
    setOpenModalDelete(!openModalDelete)
  }

  return (
    <div className='inchat-drafts'>
      <div className='header'>
        <span className='title-drafts'>{lang('dashboard_drafts-scheduled-messages')}</span>
        {/* Menu selector */}
        <BarSelector
          options={[
            { id: 'drafts', name: 'Borradores' },
            { id: 'scheduled', name: 'Programados' }
          ]}
          value={page}
          onChange={({ id }) => history.push({
            pathname: '/dashboard/conversations/inchat',
            search: `?section=${id}`
          })}
        />
      </div>

      <div className='content'>
        {/* Drafts content */}
        {page === 'drafts' ? (
          <DraftsContent
            count={inchat.drafts}
            drafts={drafts}
            getDrafts={getDrafts}
            setMessageTemp={setMessageTemp}
            toggleScheduleMsgModal={toggleScheduleMsgModal}
            toggleDelete={toggleDelete}
          />
        ) : null}
        {/* Scheduled content */}
        {page === 'scheduled' ? <ScheduledContent /> : null}
      </div>

      {/* Schedule Msg Modal */}
      {isOpenScheduleMsgModal ? (
        <ScheduleMsgModal
          isOpen={isOpenScheduleMsgModal}
          toggle={toggleScheduleMsgModal}
          onSchedule={({ iso }) => scheduleMessage(iso)}
          isSubmitting={isSchedulingMessage}
          errorText={schedulingMessageError}
        />
      ) : null}

      {/* Delete Draft Modal */}
      <ModalDelete
        isOpen={openModalDelete}
        toggle={toggleDelete}
        header={lang(`message_delete_modal_header`)}
        text1={lang(`message_delete_modal_text_1`)}
        text2={lang(`message_delete_modal_legend`)}
        event={deleteMessage}
        isSubmitting={isSubmitDelete}
      />
    </div>
  )
}

export default Drafts
